import { render, staticRenderFns } from "./PrintBarcodeBook.vue?vue&type=template&id=13a54d37&scoped=true&"
import script from "./PrintBarcodeBook.vue?vue&type=script&lang=ts&"
export * from "./PrintBarcodeBook.vue?vue&type=script&lang=ts&"
import style0 from "./PrintBarcodeBook.vue?vue&type=style&index=0&id=13a54d37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a54d37",
  null
  
)

export default component.exports